import { render, staticRenderFns } from "./ultimopiatto.vue?vue&type=template&id=6f031b13&scoped=true"
import script from "./ultimopiatto.vue?vue&type=script&lang=js"
export * from "./ultimopiatto.vue?vue&type=script&lang=js"
import style0 from "./ultimopiatto.vue?vue&type=style&index=0&id=6f031b13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f031b13",
  null
  
)

export default component.exports